const base = {
  success:    "#10b981",
  successDim: "rgba(16,185,129,0.12)",
  danger:     "#ef4444",
  dangerDim:  "rgba(239,68,68,0.12)",
  warning:    "#f59e0b",
  warningDim: "rgba(245,158,11,0.12)",
  info:       "#3b82f6",
  infoDim:    "rgba(59,130,246,0.12)",
  purple:     "#8b5cf6",
  purpleDim:  "rgba(139,92,246,0.12)",
  mutedL:     "rgba(255,255,255,0.25)",
  radius:     "16px",
  radiusSm:   "10px",
  radiusMd:   "12px",
};

export const THEMES = {
  dark_indigo: {
    name:"🌙 Sombre Indigo",
    accent:"#6366f1", accentDim:"rgba(99,102,241,0.12)",
    bg:"#0a0b0f", card:"#111318", sidebar:"#0d0f14",
    border:"rgba(255,255,255,0.07)", borderHover:"rgba(255,255,255,0.12)",
    text:"#f1f2f6", muted:"rgba(241,242,246,0.45)", mutedL:"rgba(241,242,246,0.28)",
    shadow:"0 4px 24px rgba(0,0,0,0.5)",
    shadowAccent:"0 8px 24px rgba(99,102,241,0.3)",
    gradient:"linear-gradient(135deg,#6366f1,#8b5cf6)",
    dark:true, ...base
  },
  dark_purple: {
    name:"🌙 Sombre Violet",
    accent:"#8b5cf6", accentDim:"rgba(139,92,246,0.12)",
    bg:"#09090f", card:"#100f17", sidebar:"#0c0b13",
    border:"rgba(255,255,255,0.07)", borderHover:"rgba(255,255,255,0.12)",
    text:"#f1f0ff", muted:"rgba(241,240,255,0.45)", mutedL:"rgba(241,240,255,0.28)",
    shadow:"0 4px 24px rgba(0,0,0,0.5)",
    shadowAccent:"0 8px 24px rgba(139,92,246,0.3)",
    gradient:"linear-gradient(135deg,#8b5cf6,#a78bfa)",
    dark:true, ...base
  },
  dark_green: {
    name:"🌙 Sombre Émeraude",
    accent:"#10b981", accentDim:"rgba(16,185,129,0.12)",
    bg:"#090f0d", card:"#0f1712", sidebar:"#0b1210",
    border:"rgba(255,255,255,0.07)", borderHover:"rgba(255,255,255,0.12)",
    text:"#f0fff8", muted:"rgba(240,255,248,0.45)", mutedL:"rgba(240,255,248,0.28)",
    shadow:"0 4px 24px rgba(0,0,0,0.5)",
    shadowAccent:"0 8px 24px rgba(16,185,129,0.3)",
    gradient:"linear-gradient(135deg,#10b981,#059669)",
    dark:true, ...base
  },
  dark_orange: {
    name:"🌙 Sombre Ambre",
    accent:"#f59e0b", accentDim:"rgba(245,158,11,0.12)",
    bg:"#0f0d09", card:"#17130f", sidebar:"#120f0b",
    border:"rgba(255,255,255,0.07)", borderHover:"rgba(255,255,255,0.12)",
    text:"#fffbf0", muted:"rgba(255,251,240,0.45)", mutedL:"rgba(255,251,240,0.28)",
    shadow:"0 4px 24px rgba(0,0,0,0.5)",
    shadowAccent:"0 8px 24px rgba(245,158,11,0.3)",
    gradient:"linear-gradient(135deg,#f59e0b,#ef4444)",
    dark:true, ...base
  },
  dark_slate: {
    name:"🌙 Sombre Slate",
    accent:"#818cf8", accentDim:"rgba(129,140,248,0.12)",
    bg:"#09090b", card:"#18181b", sidebar:"#0c0c0e",
    border:"#27272a", borderHover:"#3f3f46",
    text:"#fafafa", muted:"rgba(250,250,250,0.45)", mutedL:"rgba(250,250,250,0.28)",
    shadow:"0 4px 24px rgba(0,0,0,0.5)",
    shadowAccent:"0 8px 24px rgba(129,140,248,0.25)",
    gradient:"linear-gradient(135deg,#818cf8,#a78bfa)",
    dark:true, ...base,
    success:"#4ade80", danger:"#f87171", warning:"#fbbf24", info:"#60a5fa", purple:"#c084fc",
    successDim:"rgba(74,222,128,0.12)", dangerDim:"rgba(248,113,113,0.12)",
    warningDim:"rgba(251,191,36,0.12)", infoDim:"rgba(96,165,250,0.12)", purpleDim:"rgba(192,132,252,0.12)",
  },
  light_clean: {
    name:"☀️ Clair Blanc",
    accent:"#6366f1", accentDim:"rgba(99,102,241,0.08)",
    bg:"#f8f9fc", card:"#ffffff", sidebar:"#ffffff",
    border:"rgba(0,0,0,0.07)", borderHover:"rgba(0,0,0,0.13)",
    text:"#0f1017", muted:"rgba(15,16,23,0.5)", mutedL:"rgba(15,16,23,0.35)",
    shadow:"0 2px 16px rgba(0,0,0,0.07)",
    shadowAccent:"0 8px 24px rgba(99,102,241,0.2)",
    gradient:"linear-gradient(135deg,#6366f1,#8b5cf6)",
    dark:false, ...base,
    success:"#059669", danger:"#dc2626", warning:"#d97706",
  },
  light_indigo: {
    name:"☀️ Clair Indigo",
    accent:"#4f46e5", accentDim:"rgba(79,70,229,0.08)",
    bg:"#eef0ff", card:"#ffffff", sidebar:"#f5f4ff",
    border:"rgba(79,70,229,0.1)", borderHover:"rgba(79,70,229,0.2)",
    text:"#1e1b4b", muted:"rgba(30,27,75,0.5)", mutedL:"rgba(30,27,75,0.35)",
    shadow:"0 2px 16px rgba(79,70,229,0.1)",
    shadowAccent:"0 8px 24px rgba(79,70,229,0.25)",
    gradient:"linear-gradient(135deg,#4f46e5,#7c3aed)",
    dark:false, ...base,
    success:"#059669", danger:"#dc2626", warning:"#d97706",
  },
  light_green: {
    name:"☀️ Clair Vert",
    accent:"#059669", accentDim:"rgba(5,150,105,0.08)",
    bg:"#f0fdf9", card:"#ffffff", sidebar:"#f0fdf9",
    border:"rgba(5,150,105,0.1)", borderHover:"rgba(5,150,105,0.2)",
    text:"#022c22", muted:"rgba(2,44,34,0.5)", mutedL:"rgba(2,44,34,0.35)",
    shadow:"0 2px 16px rgba(5,150,105,0.1)",
    shadowAccent:"0 8px 24px rgba(5,150,105,0.25)",
    gradient:"linear-gradient(135deg,#059669,#10b981)",
    dark:false, ...base,
    success:"#059669", danger:"#dc2626", warning:"#d97706",
  },
  gsgroup: {
    name:"☀️ GS-GROUP",
    accent:"#4361EE", accentDim:"rgba(67,97,238,0.07)",
    bg:"#F7F8FC", card:"#FFFFFF", sidebar:"#FFFFFF",
    border:"rgba(15,20,40,0.08)", borderHover:"rgba(15,20,40,0.15)",
    text:"#0F1428", muted:"rgba(15,20,40,0.45)", mutedL:"rgba(15,20,40,0.3)",
    shadow:"0 1px 2px rgba(0,0,0,0.04), 0 2px 8px rgba(0,0,0,0.04)",
    shadowAccent:"0 4px 20px rgba(67,97,238,0.18)",
    gradient:"linear-gradient(135deg,#4361EE,#7B61FF)",
    dark:false, ...base,
    success:"#12B76A", danger:"#F04438", warning:"#F79009",
    successDim:"rgba(18,183,106,0.09)",
    dangerDim:"rgba(240,68,56,0.09)",
    warningDim:"rgba(247,144,9,0.09)",
    purple:"#7B61FF", purpleDim:"rgba(123,97,255,0.09)",
    mutedL:"rgba(15,20,40,0.3)",
  },
};

export const getTheme = (id) => ({ ...(THEMES[id]||THEMES.dark_indigo) });
